import React, { useMemo, useCallback } from 'react';
import cn from 'classnames';
import { func, shape } from 'prop-types';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { LOCATION } from '../../../bi/mixpanel/constants';
import { BRIEF_DATA } from '../../../Listings/constants';
import { useIndustriesContext } from '../../../shared/IndustriesContext';
import { MPI_INDUSTRIES_FILTER_MAX_TAGS } from '../../shared/constants';
import FilterCarousel from '../shared/FilterCarousel';
import commonClasses from '../shared/filter.module.scss';
import IndustryPicker from '../../../IndustryPicker';
import {
    CAROUSEL_BREAKPOINTS,
    CAROUSEL_INDUSTRIES_SLUGS,
    DEFAULT_SLIDES_TO_SHOW,
} from './constants';
import classes from './index.module.scss';

const IndustryFilter = ({ briefData, setBriefData }) => {
    const { getIndustryTitle } = useIndustriesContext();
    const slides = useMemo(
        () =>
            CAROUSEL_INDUSTRIES_SLUGS.map((industry) => ({
                ...industry,
                title: getIndustryTitle(industry.slug),
            })),
        [getIndustryTitle]
    );
    const updateBriefIndustries = useCallback(
        (industries) => {
            setBriefData({ industries }, { location: LOCATION.STATIC });
        },
        [setBriefData]
    );

    return (
        <div className={classes.industriesWrapper}>
            <div
                className={cn(
                    commonClasses.filterWrapper,
                    classes.industriesPickerWrapper
                )}
            >
                <label className={commonClasses.label}>
                    <div className={commonClasses.caption}>
                        <span>
                            <I18n k="variations_display.marketplace_listing.filters.industry.title" />
                        </span>
                        <span className={commonClasses.secondary}>
                            <I18n k="variations_display.marketplace.modal.make_your_logo.industry_input.restriction" />
                        </span>
                    </div>

                    <IndustryPicker
                        values={briefData.industries}
                        className={classes.industryPicker}
                        onChange={updateBriefIndustries}
                        hideTags={true}
                        placeholder={translate(
                            'variations_display.marketplace_listing.brief.placeholder.industries'
                        )}
                    />
                </label>
            </div>

            <div className={classes.industryCarouselWrapper}>
                <div className={classes.industriesCarouselTitle}>
                    <I18n k="variations_display.marketplace_listing.filters.industry.carousel_title" />
                </div>
                <FilterCarousel
                    slides={slides}
                    className={classes.industryCarousel}
                    maxElements={MPI_INDUSTRIES_FILTER_MAX_TAGS}
                    selected={briefData.industries}
                    breakpoints={CAROUSEL_BREAKPOINTS}
                    slidesToShow={DEFAULT_SLIDES_TO_SHOW}
                    onChange={(value) => {
                        setBriefData(
                            { industries: value },
                            { location: LOCATION.STATIC, viaCarousel: true }
                        );
                    }}
                />
            </div>
        </div>
    );
};

IndustryFilter.propTypes = {
    briefData: shape(BRIEF_DATA),
    setBriefData: func,
};

export default IndustryFilter;
